<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <h2>PDF生成系统</h2>
        <p>请登录您的账户</p>
      </div>

      <el-form
        ref="loginForm"
        :model="loginData"
        :rules="rules"
        class="login-form"
        @submit.prevent="handleLogin"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginData.username"
            placeholder="用户名"
            size="large"
            prefix-icon="User"
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="loginData.password"
            type="password"
            placeholder="密码"
            size="large"
            prefix-icon="Lock"
            @keyup.enter="handleLogin"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="large"
            style="width: 100%"
            :loading="loading"
            @click="handleLogin"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import axios from "axios";

export default {
  name: "Login",
  setup() {
    const router = useRouter();
    const loginForm = ref(null);
    const loading = ref(false);

    const loginData = reactive({
      username: "",
      password: "",
    });

    const rules = {
      username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
      password: [{ required: true, message: "请输入密码", trigger: "blur" }],
    };

    const handleLogin = async () => {
      if (!loginForm.value) return;

      try {
        await loginForm.value.validate();
        loading.value = true;

        const response = await axios.post("/api/login", loginData);
        const { token, is_admin, message } = response.data;

        localStorage.setItem("token", token);
        localStorage.setItem("isAdmin", is_admin ? "true" : "false");

        ElMessage.success(message);
        router.push("/dashboard");
      } catch (error) {
        if (error.response) {
          ElMessage.error(error.response.data.message || "登录失败");
        } else {
          ElMessage.error("网络错误，请稍后重试");
        }
      } finally {
        loading.value = false;
      }
    };

    return {
      loginForm,
      loginData,
      rules,
      loading,
      handleLogin,
    };
  },
};
</script>

<style scoped>
.login-container {
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-box {
  width: 400px;
  max-width: 90vw;
  padding: 40px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .login-box {
    width: 90vw;
    padding: 30px 20px;
    margin: 20px;
  }
  
  .login-header h2 {
    font-size: 20px;
  }
  
  .login-tips {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .login-box {
    width: 95vw;
    padding: 25px 15px;
    margin: 10px;
  }
  
  .login-header h2 {
    font-size: 18px;
  }
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h2 {
  color: #333;
  margin-bottom: 10px;
}

.login-header p {
  color: #666;
  margin: 0;
}

.login-form {
  margin-bottom: 20px;
}

.login-tips {
  text-align: center;
  color: #999;
  font-size: 12px;
  border-top: 1px solid #eee;
  padding-top: 15px;
}

.login-tips p {
  margin: 5px 0;
}
</style>
